// Русская локализация AG Grid v35 (community).
// Покрывает: пагинацию, фильтры, сортировку, no-rows и loading-overlay,
// агрегаты, set-filter. Передаётся пропом `localeText` во все таблицы.
// Без этого AG Grid в footer показывает дефолтные английские шаблоны типа
// "to of Page of" с пустыми переменными — внешний аудит 23.04 это поймал.

export const AG_GRID_LOCALE_RU: Record<string, string> = {
  // Пагинация
  page: 'Стр.',
  more: 'Ещё',
  to: 'до',
  of: 'из',
  next: 'Следующая',
  last: 'Последняя',
  first: 'Первая',
  previous: 'Предыдущая',
  loadingOoo: 'Загрузка...',
  pageSize: 'Размер страницы',
  pageSizeSelectorLabel: 'На странице:',

  // Set-фильтр / поиск
  selectAll: 'Выбрать всё',
  selectAllSearchResults: 'Выбрать всё (найденное)',
  searchOoo: 'Поиск...',
  blanks: '(пусто)',
  noMatches: 'Совпадений нет',

  // Number/text/date filter
  filterOoo: 'Фильтр...',
  equals: 'Равно',
  notEqual: 'Не равно',
  blank: 'Пусто',
  notBlank: 'Не пусто',
  empty: 'Выберите',
  lessThan: 'Меньше чем',
  greaterThan: 'Больше чем',
  lessThanOrEqual: 'Меньше или равно',
  greaterThanOrEqual: 'Больше или равно',
  inRange: 'В диапазоне',
  inRangeStart: 'От',
  inRangeEnd: 'До',
  contains: 'Содержит',
  notContains: 'Не содержит',
  startsWith: 'Начинается с',
  endsWith: 'Заканчивается на',
  andCondition: 'И',
  orCondition: 'ИЛИ',
  applyFilter: 'Применить',
  resetFilter: 'Сбросить',
  clearFilter: 'Очистить',
  cancelFilter: 'Отмена',

  // No-rows / loading
  noRowsToShow: 'Нет данных',

  // Колонки/меню
  columns: 'Колонки',
  filters: 'Фильтры',
  pinColumn: 'Закрепить',
  pinLeft: 'Закрепить слева',
  pinRight: 'Закрепить справа',
  noPin: 'Открепить',
  autosizeThisColumn: 'Автоширина',
  autosizeAllColumns: 'Автоширина всех',
  resetColumns: 'Сбросить колонки',
  copy: 'Копировать',
  copyWithHeaders: 'Копировать с заголовками',

  // Status bar (агрегаты)
  totalAndFilteredRows: 'Строк',
  totalRows: 'Всего',
  filteredRows: 'Отфильтровано',
  selectedRows: 'Выделено',
  rowGroupColumnsEmptyMessage: 'Перетащите сюда колонки для группировки',

  // Sort
  sortAscending: 'Сортировка ↑',
  sortDescending: 'Сортировка ↓',
  sortUnSort: 'Без сортировки',
}
